import React from 'react'
import {
  Container,
  Header,
  HeaderLabel,
  Divider,
  AnnouncementsList,
  AnnouncementItem,
  AnnouncementTitle,
  AnnouncementBody,
  AnnouncementLink,
  ViewMoreLink,
  ViewMoreText
} from './Styles/Announcements.styles'

const Announcements = ({ announcements = [] }) => {
  const newCount = announcements.filter(a => a && a.isNew).length

  if (announcements.length === 0) {
    return null
  }

  return (
    <Container>
      <Header>
        <HeaderLabel>Announcements</HeaderLabel>
        {newCount > 0 && (
          <>
            <Divider />
            <HeaderLabel>{newCount} New</HeaderLabel>
          </>
        )}
      </Header>

      <AnnouncementsList>
        {announcements.slice(0, 2).map((announcement, index) => {
          if (!announcement) return null

          return (
            <AnnouncementItem key={announcement.id || index} withAction={index === 1}>
              <AnnouncementTitle>{announcement.title || 'Announcement'}</AnnouncementTitle>
              <AnnouncementBody>
                {announcement.body || announcement.message || ''}
                {index === 1 && announcement.body && announcement.body.length > 150 && (
                  <>
                    ... <AnnouncementLink>Read More</AnnouncementLink>
                  </>
                )}
              </AnnouncementBody>
              {announcement.link && (
                <AnnouncementLink>{announcement.label || 'Learn More'}</AnnouncementLink>
              )}
            </AnnouncementItem>
          )
        })}
      </AnnouncementsList>

      <ViewMoreLink>
        <ViewMoreText>View More Announcements</ViewMoreText>
        <i className='fa fa-angle-right' style={{ color: '#0082CE' }} />
      </ViewMoreLink>
    </Container>
  )
}

export default Announcements
